import { render, staticRenderFns } from "./info.vue?vue&type=template&id=c5bb0706&scoped=true&"
var script = {}
import style0 from "./info.vue?vue&type=style&index=0&id=c5bb0706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bb0706",
  null
  
)

export default component.exports